
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { configStore } from "@/store/store";

@Component
export default class FontFamilyInput extends Vue {
  @Prop()
  value: unknown;

  get items() {
    return configStore.fonts.map(font => {
      return {
        text: font.label,
        value: font.slug
      };
    });
  }

  edit(font: string) {
    if (!font) {
      // eslint-disable-next-line no-param-reassign
      font = "";
    }
    this.$emit("input", font);
  }
}
